import { render, staticRenderFns } from "./ChangeUser.vue?vue&type=template&id=38985e8f&"
import script from "./ChangeUser.vue?vue&type=script&lang=js&"
export * from "./ChangeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports